import { getLocale } from "../runtime";

const sv_mtcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Malta`
};

const mtcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_mtcountry(inputs)
	return "mtCountry";
};

export { mtcountry as "mtCountry" };